export default {"src":"/_next/static/media/calculator.2478fa18.svg","height":32,"width":32};